import { Component, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { $BroadcastManagerService } from '../../BroadcastManager.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-voicehdr-dialog',
  templateUrl: './voicehdr-dialog.component.html',
  styleUrls: ['./voicehdr-dialog.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class VoicehdrDialogComponent {
  public onClose: Subject<boolean>;
  
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild('tSort') tSort: MatSort;
  dataSource: MatTableDataSource<any>;

  constructor(
    public bsModalRef: BsModalRef,
    private $: $BroadcastManagerService
    ) { }

    displayedColumns: string[] = [
      'vhurn',
      'cli',
      'peid',
      'pename',
      'tmid',
      'tmname',
      'event',
      'sts',
      'AssignedDate',
      'LastActionDate',
      'updatedBy',
      'Remarks',
      'OtherRegRemarks',
      'AdditionalRegComments'
    ];

  public ngOnInit(): void {
      this.onClose = new Subject();
  }

  public onConfirm(): void {
    this.onClose.next(true);
    this.bsModalRef.hide();
    console.log("Clicked Ok")
}

}
